const bankAccountNumberSeparator = ' ';

export const parseFormattedBankAccountNumberIntoBankAccountNumber = (bankAccountNumber: string) =>
    bankAccountNumber.replaceAll(bankAccountNumberSeparator, '');
